import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import Alert from '@/components/Alert';

/**
 * Shown when Stripe.js failed to load (TENANT-ADMIN-PROD-30). Without it the
 * payment UI is silently inert — InvoicePayCheckoutModal's handler returns
 * early on a null stripe and the card fields never mount, with nothing on
 * screen to explain why.
 */
const StripeUnavailableAlert = () => (
  <Alert
    description="We couldn't load our payment provider. This is usually caused by an ad blocker or privacy extension — please disable it for this site and reload, or try another browser."
    icon={faExclamationTriangle}
    status="danger"
    title="Payment form unavailable"
  />
);

export default StripeUnavailableAlert;
